// extracted by mini-css-extract-plugin
export default {"institutions":"src-modules-page-blocks-InstitutionList-style__institutions_zNUaT"};